module.exports = __webpack_public_path__ + "img/imageImport.d37986d.png";